module.exports = __webpack_public_path__ + "h5/img/ylj.684058df.jpg";